import { SensorOrSubSensorInfoWithoutSection } from '@components/cockpit/panels/monitoring/monitoring.types';
import { isSensorOrSubSensorInfoOfType } from '@components/cockpit/panels/monitoring/monitoring.utils';

import { SensorTypeEnum } from '@/types/sensor/sensors';

import Dfb6MaintenanceActions from './Dfb6MaintenanceActions';
import HolodroneMaintenanceActions from './HolodroneMaintenanceActions';
import HolopticsMaintenanceActions from './HolopticsMaintenanceActions';
import ZmerMaintenanceActions from './ZmerMaintenanceActions';

type SpecificMaintenanceActionsProps = {
  sensorOrSubSensorInfo: SensorOrSubSensorInfoWithoutSection;
  replayMode?: boolean;
};

export default function SpecificMaintenanceActions({
  sensorOrSubSensorInfo,
  replayMode = false,
}: Readonly<SpecificMaintenanceActionsProps>) {
  switch (sensorOrSubSensorInfo.type) {
    case SensorTypeEnum.DFB6: {
      if (isSensorOrSubSensorInfoOfType(sensorOrSubSensorInfo, SensorTypeEnum.DFB6)) {
        return (
          <Dfb6MaintenanceActions
            selectedMode={sensorOrSubSensorInfo.status?.selectedMode ?? null}
            configuration={sensorOrSubSensorInfo.configuration}
            replayMode={replayMode}
          />
        );
      }
      return null;
    }
    case SensorTypeEnum.ZMER: {
      if (isSensorOrSubSensorInfoOfType(sensorOrSubSensorInfo, SensorTypeEnum.ZMER)) {
        return <ZmerMaintenanceActions sensorOrSubSensorInfo={sensorOrSubSensorInfo} replayMode={replayMode} />;
      }
      return null;
    }
    case SensorTypeEnum.HOLODRONE: {
      if (isSensorOrSubSensorInfoOfType(sensorOrSubSensorInfo, SensorTypeEnum.HOLODRONE)) {
        return <HolodroneMaintenanceActions sensorOrSubSensorInfo={sensorOrSubSensorInfo} replayMode={replayMode} />;
      }
      return null;
    }
    case SensorTypeEnum.AF2206: {
      if (
        sensorOrSubSensorInfo.status === null ||
        !isSensorOrSubSensorInfoOfType(sensorOrSubSensorInfo, SensorTypeEnum.AF2206)
      ) {
        return null;
      }
      return <HolopticsMaintenanceActions sensorOrSubSensorInfo={sensorOrSubSensorInfo} replayMode={replayMode} />;
    }
    default:
      return null;
  }
}
